import {
  TableauParameter,
  TableauParameterSelection,
} from "@/components/tableau/types"
import {
  formatParameter,
  initializeParameterSelections,
} from "@/components/tableau/utils"
import { useCallback, useState } from "react"

export function useTableauParameters(
  vizRef: React.MutableRefObject<any | null>
) {
  const [parameters, setParameters] = useState<TableauParameter[]>([])
  const [selectedParameters, setSelectedParameters] =
    useState<TableauParameterSelection>({})

  const getWorkbookParameters = useCallback(async () => {
    if (!vizRef.current) return []

    try {
      const workbook = vizRef.current?.workbook
      if (!workbook) return []

      const parameters = await workbook.getParametersAsync()

      const parameterDetails = parameters.map(formatParameter)
      console.log("Parameter details:", parameterDetails)

      setParameters(parameterDetails)

      // initialize selected parameters with current values
      const initialSelectedParams =
        initializeParameterSelections(parameterDetails)

      setSelectedParameters(initialSelectedParams)

      return parameterDetails
    } catch (error) {
      console.error("Error getting parameters:", error)
      return []
    }
  }, [vizRef])

  const changeParameterValue = useCallback(
    async (paramName: string, newValue: any) => {
      setSelectedParameters((prev) => ({
        ...prev,
        [paramName]: newValue,
      }))

      if (vizRef.current) {
        const workbook = vizRef.current?.workbook

        if (!workbook) {
          console.warn(
            `Workbook not available when changing parameter ${paramName}`
          )
          return
        }

        workbook
          .changeParameterValueAsync(paramName, newValue)
          .then(() => {
            console.log(`Parameter ${paramName} changed to ${newValue}`)
          })
          .catch((error: any) =>
            console.error(`Error changing parameter ${paramName}:`, error)
          )
      }
    },
    [vizRef]
  )

  return {
    parameters,
    selectedParameters,
    getWorkbookParameters,
    changeParameterValue,
  }
}
